/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import dayjs from "dayjs"
import { convertDateTZ } from "utils/date_formatter"

interface RangeTimeFormat {
  Left: string
  Right: string
}

export const dayArray = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"]
export const monthArray = [
  "jan",
  "feb",
  "mar",
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sep",
  "oct",
  "nov",
  "dec",
]

export const countTimeDifferentInMinutes = (
  startTime: Date,
  endTime: Date,
): number => {
  const difference = endTime.getTime() - startTime.getTime()
  return Math.round(difference / 60000)
}

export const countTimeDifferentInDays = (
  startTime: Date,
  endTime: Date,
): number => {
  const difference = endTime.getTime() - startTime.getTime()
  return Math.round(difference / (24 * 3600 * 1000))
}

export const getTimeFormat = (is24h: boolean): string =>
  is24h ? "HH:mm" : "hh:mm A"

export const getRangeTimeFormat = (is24h: boolean): RangeTimeFormat => {
  const result: RangeTimeFormat = {
    Left: "hh:mm",
    Right: getTimeFormat(is24h),
  }

  if (is24h) {
    result.Left = "HH:mm"
    result.Right = getTimeFormat(is24h)
  }

  return result
}

export const getTodayFormatTime = (time: string) => {
  const todayFormatTime = convertDateTZ(
    `${dayjs().format("YYYY-MM-DD")} ${time}`,
  ).format()
  return todayFormatTime
}

export const formatPauseEndingTime = (pauseEndingTime: string) => {
  const dateObj = new Date(pauseEndingTime)
  const timeFormatter = new Intl.DateTimeFormat("default", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  })
  const dayFormatter = new Intl.DateTimeFormat("default", {
    day: "2-digit",
  })
  const monthFormatter = new Intl.DateTimeFormat("default", {
    month: "short",
  })
  return `${timeFormatter.format(dateObj)},
  ${dayFormatter.format(dateObj)} ${monthFormatter.format(dateObj)}`
}
